module.exports = __webpack_public_path__ + "school/img/practiceHistoryBg.c9976d0f.jpg";